module.exports = __webpack_public_path__ + "static/media/channel.26bb8f84.svg";